// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./car.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.progress {
  position: relative;
  height: 60px;
  line-height: 35px;
  background: #809495;
  box-shadow: none;
  margin: 0;
  overflow: visible;
}
.progress:after {
  content: "";
  display: block;
  position: relative;
  top: 27px;
  border-top: 4px dashed #fff;
}
.progressbar-title {
  color: #d8dedc;
  font-size: 15px;
  margin: 5px 0;
  font-weight: bold;
}
.path {
  min-height: 6px;
  background: linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, #FFF 51.56%, rgba(255, 255, 255, 0) 100%);
  opacity: 0.4;
}
.progress .progress-bar {
  position: relative;
  animation: animate-positive 2s;
}
.progress-bar {
  float: left;
  height: 100%;
  font-size: 12px;
  line-height: 20px;
  color: #fff;
  text-align: center;
  background-color: #333;
  box-shadow: inset 0 -1px 0 rgba(0, 0, 0, 0.15);
  transition: width 0.6s ease;
}
.progress .progress-bar span {
  position: absolute;
  top: -40px;
  right: -40px;
  color: #fff;
  display: block;
  font-size: 17px;
  font-weight: bold;
  /* padding: 5px 7px; */
  background: #333;
  border-radius: 0 0 5px 5px;
}
.progress .progress-bar span:after {
  content: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  color: #333;
  position: absolute;
  top: 24px;
  right: -70px;
  z-index: 10;
}
.year {
  color: #FFF;
  text-align: center;
  font-size: 26px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  letter-spacing: -0.52px;
  text-transform: uppercase;
}
@-webkit-keyframes animate-positive {
  0% {
    width: 0%;
  }
}
@keyframes animate-positive {
  0% {
    width: 0%;
  }
}
@media screen and (max-width: 767px) {
  .year {
    font-size: 16px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/views/about/less/process.less"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,YAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,SAAA;EACA,iBAAA;AACF;AACA;EACE,WAAA;EACA,cAAA;EACA,kBAAA;EACA,SAAA;EACA,2BAAA;AACF;AACA;EACE,cAAA;EACA,eAAA;EACA,aAAA;EACA,iBAAA;AACF;AACA;EACE,eAAA;EACA,uGAAA;EACA,YAAA;AACF;AACA;EACE,kBAAA;EACA,8BAAA;AACF;AACA;EACE,WAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;EACA,WAAA;EACA,kBAAA;EACA,sBAAA;EACA,8CAAA;EACA,2BAAA;AACF;AACA;EACE,kBAAA;EACA,UAAA;EACA,YAAA;EACA,WAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAsB;EACtB,gBAAA;EACA,0BAAA;AACF;AACA;EACE,gDAAA;EACA,WAAA;EACA,kBAAA;EACA,SAAA;EACA,YAAA;EACA,WAAA;AACF;AACA;EACE,WAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBAAA;AACF;AACA;EACE;IAAK,SAAA;EAEL;AACF;AADA;EACE;IAAK,SAAA;EAIL;AACF;AAFA;EACE;IACE,eAAA;EAIF;AACF","sourcesContent":[".progress{\n  position: relative;\n  height: 60px;\n  line-height: 35px;\n  background: #809495;\n  box-shadow: none;\n  margin:0;\n  overflow: visible;\n}\n.progress:after{\n  content: \"\";\n  display: block;\n  position: relative;\n  top: 27px;\n  border-top: 4px dashed #fff;\n}\n.progressbar-title{\n  color:#d8dedc;\n  font-size:15px;\n  margin:5px 0;\n  font-weight: bold;\n}\n.path {\n  min-height: 6px;\n  background: linear-gradient(90deg, rgba(255, 255, 255, 0.00) 0%, #FFF 51.56%, rgba(255, 255, 255, 0.00) 100%);\n  opacity: 0.4;\n}\n.progress .progress-bar{\n  position: relative;\n  animation: animate-positive 2s;\n}\n.progress-bar {\n  float: left;\n  height: 100%;\n  font-size: 12px;\n  line-height: 20px;\n  color: #fff;\n  text-align: center;\n  background-color: #333;\n  box-shadow: inset 0 -1px 0 rgba(0,0,0,.15);\n  transition: width .6s ease;\n}\n.progress .progress-bar span{\n  position: absolute;\n  top: -40px;\n  right: -40px;\n  color: #fff;\n  display: block;\n  font-size: 17px;\n  font-weight: bold;\n  /* padding: 5px 7px; */\n  background: #333;\n  border-radius: 0 0 5px 5px;\n}\n.progress .progress-bar span:after{\n  content: url('./car.svg');\n  color: #333;\n  position: absolute;\n  top: 24px;\n  right: -70px;\n  z-index: 10;\n}\n.year {\n  color: #FFF;\n  text-align: center;\n  font-size: 26px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n  letter-spacing: -0.52px;\n  text-transform: uppercase;\n}\n@-webkit-keyframes animate-positive {\n  0% { width: 0%;}\n}\n@keyframes animate-positive {\n  0% { width:0%; }\n}\n\n@media screen and (max-width: 767px) {\n  .year {\n    font-size: 16px;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
